module.exports = __webpack_public_path__ + "img/pay_wancheng.9504e300.png";